import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import StudentRegistration from "./pages/StudentRegistration";
import Quiz from "./pages/Quiz";
import Submitted from "./pages/Submitted";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<StudentRegistration />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/submitted" element={<Submitted />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/panel" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;